const PatMedHistState = {
  data: {}
}

export default PatMedHistState
